import type { FilePreviewProps } from './types'

type StoredFolder = Exclude<FilePreviewProps['folder'], 'tmp-apply-file'>
const storedFolders: readonly StoredFolder[] = [
    'candidate',
    'candidate_course',
    'work',
    'work_trip',
    'ad_file',
    'corporation_page',
    'newsfeed',
    'ad-question-file',
]

function positiveId(value: unknown): number | null {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) return null
    const id = Number(value)
    return Number.isSafeInteger(id) && id > 0 ? id : null
}

/** URL/Recman Document and local upload previews still need the legacy viewer. */
export function getStoredFilePreviewAuth(
    fileId: unknown,
    folder: StoredFolder,
    details: { extension?: string; fileType?: number | null; kind?: string; local?: boolean } = {}
): FilePreviewProps | null {
    if (
        details.local ||
        details.fileType === 2 ||
        details.fileType === 3 ||
        ['url', 'document', 'html'].includes(details.kind ?? '') ||
        ['html', 'recmandocument'].includes(details.extension?.toLowerCase() ?? '')
    )
        return null
    const id = positiveId(fileId)
    return id && storedFolders.includes(folder) ? { fileId: id, folder } : null
}

/** The server supplies folder; temporary types 5/6/8 are CV/course/attachment. */
export function getApplyFilePreviewAuth(file: unknown, uid?: string): FilePreviewProps | null {
    if (!file || typeof file !== 'object') return null
    const data = file as Record<string, unknown>
    if (typeof data.folder !== 'string') return null
    if (data.folder !== 'tmp-apply-file') {
        if (!storedFolders.includes(data.folder as StoredFolder)) return null
        return getStoredFilePreviewAuth(data.existingId, data.folder as StoredFolder, {
            extension: typeof data.ext === 'string' ? data.ext : undefined,
        })
    }
    if (!uid || typeof data.uid !== 'string' || !data.uid || ![5, 6, 8].includes(Number(data.type))) return null
    if (typeof data.type !== 'number' || !Number.isInteger(data.type)) return null
    return { uid, fileUid: data.uid, type: data.type, folder: 'tmp-apply-file' }
}
